import axios from "axios";

export function getCoinPrice(
  uniswapVersion, // v2 or v3
  routerOrQuoterAddress,
  path, // array of token addresses
  fees, // array of fees, if v3
) {
  return axios.get('/price/coin', {
    params: {
      uniswapVersion,
      routerOrQuoterAddress,
      path,
      fees,
    }
  });
}
